import { createSlice } from '@reduxjs/toolkit';
import Api from 'services/api';
import { PAGELENGTH } from 'components/common/ListLayout';
import toast from 'react-hot-toast';

export const initialState = {
  reports: [],
  error: null,
  loader: false,
  listLoading: false,
  total: 0,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

const apReportSlice = createSlice({
  name: 'apReport',
  initialState,
  reducers: {
    setReports: (state, { payload }) => {
      console.log("🔥 Payload in setReports:", payload);

      const paginated = payload?.data ?? {};
      const data = paginated?.data ?? [];

      state.reports = Array.isArray(data) ? data : [];
      state.total = paginated?.total ?? 0;
      state.last_page = paginated?.last_page ?? 1;
      state.current_page = paginated?.current_page ?? 1;
      state.per_page = paginated?.per_page ?? PAGELENGTH;

    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    setListLoader: (state, { payload }) => {
      state.listLoading = payload;
    },
  },
});

export const { setReports, setError, setLoader, setListLoader } = apReportSlice.actions;
export default apReportSlice.reducer;

export const apReportSelector = (state) => state.apReport;

// ==============================
// 🚀 Async Actions
// ==============================

// Get AP Reports List
export const fetchApReports = (page = 1, params = {}, disableLoader = false) => async (dispatch) => {
  if (!disableLoader) dispatch(setLoader(true));
  dispatch(setListLoader(true));

  try {
    const response = await Api.fetchApReports(page, params);

    // Axios response contains data inside response.data
    if (response.status >= 200 && response.status < 300) {
      // Ensure we pass the actual object containing data, total, etc.
      dispatch(setReports(response.data));
    } else {
      dispatch(setError(response.data));
    }
  } catch (error) {
    console.log("fetchApReports error:", error);
    dispatch(setError(error.response?.data || error.message));
  }

  if (!disableLoader) dispatch(setLoader(false));
  dispatch(setListLoader(false));
};

// Mark report as Paid
export const markReportAsPaid = (id, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));

  try {
    const response = await Api.statusChange(id, { status: 'paid' }, 'ap_reports');
    if (response.status >= 200 && response.status < 300) {
      callback?.(true, response.data.message);
      dispatch(fetchApReports());
    } else {
      dispatch(setError(response.data));
      callback?.(false, response.data.message);
    }
  } catch (error) {
    console.log("markReportAsPaid error:", error);
    dispatch(setError(error.response?.data || error.message));
    callback?.(false, error.message);
  }

  dispatch(setLoader(false));
};

export const downloadConsolidatedInvoice = (reportId) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await Api.downloadConsolidatedInvoice(reportId);

    // Agar backend se PDF blob aata hai
    if (response.status === 200) {
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Consolidated_Invoice_${reportId}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error("Failed to download file");
    }
  } catch (error) {
    console.error("Download error:", error);
    toast.error("Error while downloading file");
  }
  dispatch(setLoader(false));
};
